import React, { Suspense, lazy } from 'react';
import Loading from '../LoadingComponent';

const BatchesTable = lazy(() =>
  import(/* webpackChunkName: "BatchesTable" */ '../../components/rewards/BatchesTable')
);

export default function AsyncBatchesTable({...props}) {
  return (
    <Suspense fallback={<Loading />}>
      <BatchesTable {...props} />
    </Suspense>
  );
}
